import React, { Fragment } from 'react';
import { ClosePopupHoc, loaderGIF, ResetHoc, TickHoc } from '../../../assets/images';
import { blockOfflineAction, isAppOnline } from '../../../Helpers/Utility';
import {
    CROP_PHOTO, IMAGE_TYPE_ONLY_ALLOWED
} from '../../../processENV';
import { toast } from 'react-toastify';

const WebChatCroppie = (props = {}) => {
    const [croppie, setCroppie] = React.useState({file:{}});
    const {file} = croppie;
    /**
     * handleProfileCameraClose() to close the crop template.
     */
    const handleProfileCameraClose = (e) => {
        props.closePopUp()
    }

    /**
     * validateBeforeUpload() to validate the uploaded image.
     */
    const validateBeforeUpload = (files = {}) => {
        setCroppie({
            ...croppie,
            file: files
        })
        const fileName = file.name;
        if (!(/\.(jpe?g|png|gif|bmp)$/i.test(fileName))) {
            return {
                messsage: IMAGE_TYPE_ONLY_ALLOWED,
                error: true
            }
        }
        return {
            error: false
        };
    }

    /**
     * fileChangedHandler() to handle the validations.
     */
    const fileChangedHandler = event => {
        const filed = event.target.files[0];
        const isValid = validateBeforeUpload(filed);
        event.target.value = "";
        if (!isValid.error) {
            props.updateProfileImage(filed);
            toast.error(isValid.messsage)
            event.preventDefault();
        } else {
            props.updateProfileImage(filed);
        }
    }

    /**
     * handleTick() to save the cropped image in parent component.
     */
    const handleTick = (e) => {
        if (!isAppOnline()) {
            blockOfflineAction()
            return
        }
        props.cropImage()
    }

    /**
     * render() method to render the WebChatCroppie Component into browser.
     */
    
    const loaderStyle = {
        width: 30,
        height: 29
    }
    const { loader, cameraPopup } = props
    return (
        <Fragment>
            <input
                type="file"
                accept="image/*"
                id="ProfileUpload"
                onChange={fileChangedHandler}
                onClick={props?.closeDropDown}
                data-jest-id={"jestfileChangedHandler"}
            />
            <label className="UploadLabel" htmlFor="ProfileUpload"></label>
            {cameraPopup &&
                <div className="camera-container">
                    <div className="camera-popup-visible">
                        <div className="userprofile-header">
                            <i
                                data-jest-id={"jesthandleProfileCameraClose"}
                                onClick={(e) => handleProfileCameraClose(e)}
                            >
                                <ClosePopupHoc /></i>
                            <h5>{CROP_PHOTO}</h5>
                        </div>
                        <div className="cameraview">
                            <div id="fileContainer"></div>
                        </div>
                        <div className="popup-controls">
                            {!loader &&
                                <Fragment>
                                    <i className="reset picturerReset" title="Re capture">
                                        <label htmlFor="Reset"><ResetHoc viewBox="0 0 39 39" />
                                            <input
                                                id="Reset"
                                                type="file"
                                                accept="image/*"
                                                className="imageSelect"
                                                onChange={fileChangedHandler}
                                            />
                                        </label>
                                    </i>
                                    <i className="pictureUpdate" title="Update Profile">
                                        <TickHoc
                                            viewBox="0 0 39 39"
                                            onClick={handleTick}
                                            data-jest-id={"jesthandleTick"}
                                        />
                                    </i>
                                </Fragment>
                            }
                            {loader && <img src={loaderGIF} alt="loader" style={loaderStyle} />}
                        </div>
                    </div>
                </div>}
        </Fragment>
    )
}


export default WebChatCroppie;
